import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

// 用户管理
export default {
  userList(params) { // 产品列表
    const url =  baseURL + '/tbUser/userList';
    return axios.post(url, qs.stringify(params));
  },
  
}


// WEBPACK FOOTER //
// ./src/api/user.js